import { useCallback, useState } from "react";

const useYear = (range = 4) => {
	const [year, setYear] = useState(new Date().getFullYear());

	const getLastYears = useCallback(() => {
		const currentYear = new Date().getFullYear();
		const lastFiveYears = [];

		for (let i = 0; i < range; i++) {
			lastFiveYears.push({ label: currentYear - i, key: currentYear - i });
		}

		return lastFiveYears;
	}, [range]);

	const updateYear = useCallback((value) => {
		setYear(value);
	}, []);

	return { listOfYears: getLastYears(), updateYear, year };
};

export default useYear;
